import type { HouseFurniture } from "../../models/apiTypes";
import {
  buyFurnitureInteriorObjectsInteriorObjectIdFurnitureBuyPost,
} from "../../client";
import type { QueryClient } from "@tanstack/react-query";
import { fetchHouseFurniture } from "../../scenes/room/state/layoutSync";

export { isInvoiceLinkResponse } from "../../scenes/room/furnitureApi";
// Flushes queued interior edits before reading, see layoutSync.
export { fetchHouseFurniture };

/** `place: false` — the item waits in the house inventory (the interior tutorial). */
export async function buyFurnitureViaClient(mapObjectId: number, furnitureCatalogId: number) {
  const { data } = await buyFurnitureInteriorObjectsInteriorObjectIdFurnitureBuyPost({
    path: { interior_object_id: mapObjectId },
    body: { furniture_catalog_id: furnitureCatalogId },
    throwOnError: true,
  });
  return data;
}

export function getCountByCatalog(items: HouseFurniture[], furnitureCatalogId: number) {
  return items.filter((item) => item.furniture_catalog_id === furnitureCatalogId).length;
}


export async function syncPurchasedFurnitureAfterBuy(
  queryClient: QueryClient,
  mapObjectId: number,
  furnitureCatalogId: number,
  previousCount: number
): Promise<HouseFurniture[] | null> {
  // Backend now auto-places purchased furniture.
  // Poll inventory briefly until new item appears, then push data to cache immediately.
  const maxAttempts = 12;
  const retryDelayMs = 250;
  const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  let lastItems: HouseFurniture[] | null = null;
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    const items = await fetchHouseFurniture(mapObjectId);
    lastItems = items;
    queryClient.setQueryData(["houseFurniture", mapObjectId], items);
    if (getCountByCatalog(items, furnitureCatalogId) > previousCount) {
      return items;
    }
    await sleep(retryDelayMs);
  }

  return lastItems;
}
